import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from '@whelk/components/src/Base/Button';
import { RootState } from '@whelk/store';
import { Toast } from '@whelk/components';
import { InputClearIcon } from '@whelk/assets/src/web/new-icons';
import { Input } from 'antd';

const APPEAL_EMAIL = 'APPEAL_EMAIL'; // 邮箱缓存key
/**
 * 申诉内容 填写申诉表单，内含一个填写邮箱的输入框
 * @param setIsAppeal 设置申诉状态
 * @param onAppeal 上报申诉
 * @returns
 */
const AppealContent = ({
  setIsAppealForm,
  onAppeal,
}: {
  setIsAppealForm: (isAppeal: boolean) => void;
  onAppeal: ({ email, successCb }: { email: string; successCb: () => void }) => void;
}) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState(''); // 邮箱
  const [error, setError] = useState(false);
  const realUserID = useSelector((state: RootState) => state?.user?.realUserID); // 用户id
  useEffect(() => {
    // 根据realUserID获取邮箱缓存，如果缓存不存在，则设置为空
    setEmail(localStorage?.getItem(APPEAL_EMAIL + realUserID) || '');
  }, [realUserID]);
  // 邮箱格式校验
  const verifyIsEmail = () => {
    const isEmail = email && /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(email);
    if (!isEmail) {
      setError(true);
      Toast.error('Please fill in your email address');
      return false;
    }
    return true;
  };
  // 确认申诉按钮
  const onConfirm = async () => {
    // 邮箱格式校验
    if (!verifyIsEmail()) return;
    // 上报申诉
    onAppeal({
      email,
      successCb: () => {
        // 申诉成功后缓存填写的邮箱，再次打开申诉弹窗时，邮箱会自动填充
        localStorage.setItem(APPEAL_EMAIL + realUserID, email);
      },
    });
  };
  // 返回封禁部分
  const backToBanned = () => {
    // 设置申诉状态为false
    setIsAppealForm(false);
    // 清空邮箱
    setEmail('');
    // 清空错误
    setError(false);
  };
  return (
    <div className='max-w-[460px] text-[15px] font-normal leading-[24px] text-[#AFB2BB]'>
      <div>
        {/* 邮箱输入框 */}
        <Input
          rootClassName='history-rename-input'
          allowClear={{ clearIcon: <InputClearIcon /> }}
          autoFocus={true}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setEmail(e.target.value.replace(/\s+/g, ''))
          }
          placeholder={t('Please fill in your email address')}
          status={error ? 'error' : undefined}
          onBlur={verifyIsEmail}
        />
      </div>

      <div className='mt-8 flex w-full justify-end gap-4 text-[14px] leading-[20px]'>
        <Button variant='blueText' onClick={backToBanned}>
          {t('cancel_btn')}
        </Button>
        <Button variant='blue' onClick={onConfirm}>
          {t('button_confirm')}
        </Button>
      </div>
    </div>
  );
};
export default AppealContent;
